import { useEffect } from "react";
import { useAuthStateContext } from "/src/features/auth/context/authContext";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import NotFound from "./NotFound";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from '/src/components/loader/Loader';
import SsoCallback from '/src/features/auth/components/SsoCallback/SsoCallback';

function RedirectHomeOrNotFound() {
    const [searchParams] = useSearchParams();
    const naviguate = useNavigate();
    const { user, fetching, error } = useAuthStateContext();

    const ssoSuccess = searchParams.get('sso_success');
    const ssoError = searchParams.get('error');
    const isAuthenticated = user && user.id;
    const isSsoCallback = ssoSuccess === '1' || ssoError;

    useEffect(() => {
        if (isSsoCallback || fetching) {
            return;
        }
        if (!isAuthenticated) {
            naviguate('/login');
            return;
        }
        naviguate(urlWithRoutingCompany('home'));
    }, [isAuthenticated, fetching, naviguate, isSsoCallback]);

    if (isSsoCallback) {
        return <SsoCallback />;
    }

    return <>
        { fetching == true ? <Loader/> : null}
        { error == true ? <NotFound/> : null }
    </>
}

export default RedirectHomeOrNotFound;